import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/auth-store'

export interface PlanLimit {
  limit_key: string
  limit_value: number
}

export interface SubscriptionPlan {
  id: string
  name: string
  slug: string
  description: string | null
  price_idr: number | null
  plan_features: { feature_key: string }[]
  plan_limits: PlanLimit[]
}

export interface SubscriptionData {
  status: 'active' | 'trial' | 'suspended' | 'cancelled'
  started_at: string
  expires_at: string | null
  plans: SubscriptionPlan | null
}

export function useSubscription() {
  const tenantId = useAuthStore((s) => s.currentTenant?.id)

  return useQuery({
    queryKey: ['subscription', tenantId],
    enabled: !!tenantId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tenant_subscriptions')
        .select('status, started_at, expires_at, plans(id, name, slug, description, price_idr, plan_features(feature_key), plan_limits(limit_key, limit_value))')
        .eq('tenant_id', tenantId!)
        .maybeSingle()
      if (error) throw error
      return data as unknown as SubscriptionData | null
    },
  })
}
